import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { UserPlus } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";

export default function RegisterPage() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && typeof user === "object") return <Navigate to="/dashboard" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) {
      setError("La password deve avere almeno 6 caratteri.");
      return;
    }
    setLoading(true);
    try {
      await register(email, password, name);
      navigate("/billing", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-black">
      <div className="relative flex items-center justify-center p-8 lg:p-16 carbon-gradient grid-bg">
        <div className="absolute top-6 left-8">
          <BrandLogo size={44} showText textClassName="text-base text-white" />
        </div>

        <div className="w-full max-w-md">
          <div className="mb-6">
            <div className="font-mono-tel text-xs text-yellow-500 uppercase mb-3">
              [ NUOVO COMMISSARIO ]
            </div>
            <h1 className="font-display font-black uppercase text-5xl lg:text-6xl leading-[0.9]">
              Diventa
              <br />
              <span className="text-yellow-500">Steward.</span>
            </h1>
            <p className="text-zinc-400 mt-4 max-w-sm">
              Crea il tuo profilo: ricevi <span className="text-yellow-500">1 verdetto gratis</span> di prova, poi
              attiva l'abbonamento mensile a <strong className="text-yellow-500">€15</strong>.
            </p>
          </div>

          <form onSubmit={onSubmit} className="space-y-4" data-testid="register-form">
            <div>
              <label className="section-h block">Nome Steward</label>
              <input type="text" required value={name} onChange={(e) => setName(e.target.value)}
                placeholder="Es. Marco Bianchi" className="input-field" data-testid="register-name-input" />
            </div>
            <div>
              <label className="section-h block">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="commissario@scuderia.it" className="input-field" data-testid="register-email-input" />
            </div>
            <div>
              <label className="section-h block">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="Minimo 6 caratteri" className="input-field" data-testid="register-password-input" />
            </div>

            {error && (
              <div className="border border-red-500/40 bg-red-500/10 text-red-400 text-sm p-3" data-testid="register-error">
                {error}
              </div>
            )}

            <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="register-submit-button">
              <UserPlus className="w-4 h-4" />
              {loading ? "Creazione…" : "Crea il tuo account"}
            </button>

            <div className="text-center pt-2">
              <span className="text-zinc-500 text-sm">Hai già un account? </span>
              <Link to="/login" className="text-yellow-500 hover:text-yellow-400 text-sm font-medium" data-testid="login-link">
                Accedi
              </Link>
            </div>
          </form>
        </div>
      </div>

      <div className="hidden lg:block relative bg-cover bg-center"
        style={{
          backgroundImage: "url('https://images.pexels.com/photos/29309757/pexels-photo-29309757.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400')",
        }}>
        <div className="absolute inset-0 bg-gradient-to-l from-black/30 via-black/10 to-black scanlines" />
      </div>
    </div>
  );
}
